import React, { useState } from 'react';
import { snack, ApButtonSecondary } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostLabel,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../BuildReports.styles';
import CodeSnippet from '../../../../components/CodeSnippet';
import { fetchPowerBiPBIDSFile } from '../../../../utils/api';
import { downloadObjectAsJson } from '../../../../utils/common';

interface IReportConfigurationSectionProps {
  powerBiWorkspaceName: string;
}
export const ReportConfigurationSection = ({
  powerBiWorkspaceName,
}: IReportConfigurationSectionProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handlePowerBIPBIDSFIle = async () => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      const pbidsFile = await fetchPowerBiPBIDSFile();
      downloadObjectAsJson(
        pbidsFile.data,
        'PowerBISQLServerConnection',
        'pbids'
      );
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      snack.error({
        message: 'Error loading pbids file',
      });
    }
  };

  return (
    <SectionWrapper animationIndex={0}>
      <Title>Report configuration</Title>
      <ContentBlock>
        <Description index="1">
          Download this PBID file and open using Power BI Desktop within the ETS
          VDI. This will automatically linkyour powerBi Desktop to this
          environment ready to use.
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostValue>
              <ApButtonSecondary
                iconName="download"
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                onClick={handlePowerBIPBIDSFIle}
              >
                Download PBID file
              </ApButtonSecondary>
            </CostValue>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
      <ContentBlock>
        <Description index="2">
          Build your reports in Power BI desktop.
        </Description>
      </ContentBlock>
      <ContentBlock>
        <Description index="3">
          When you&#39;re ready to share your reports with colleagues, publish
          them to your workspace.
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostLabel>Workspace name</CostLabel>
            <CodeSnippet>{powerBiWorkspaceName || 'N/A'}</CodeSnippet>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
